import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import ContractorAssistedRegistrationApi from "../../../../infrastructure/api/contractorAssistedRegistrationApi";
import AssistedRegistrationPage from "../../partner-commission/AssistedRegistrationPage";
import PartnerCommissionPageShell from "../../partner-commission/components/PartnerCommissionPageShell";
import {
  ASSISTED_REGISTRATION_NEW_QUERY,
  readAssistedRegistrationIdFromQuery,
} from "../../partner-commission/assistedRegistrationRouteUtils";
import ContractorAssistedRegistrationListPage from "./ContractorAssistedRegistrationListPage";
import ContractorAssistedRegistrationTrackingPage from "./ContractorAssistedRegistrationTrackingPage";

const LIST_BACK_PATH = "/SLN/Contractor/AssistedRegistration";

const ContractorAssistedRegistrationRouteResolver = ({ registrationId }) => {
  const [loading, setLoading] = useState(true);
  const [mode, setMode] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await ContractorAssistedRegistrationApi.getDetail(registrationId);
        if (cancelled) return;
        if (!res.isSuccess) {
          setMode("tracking");
          return;
        }
        const locked = Boolean(res.data?.isLocked ?? res.data?.IsLocked);
        const canEdit = Boolean(res.data?.canEdit ?? res.data?.CanEdit);
        setMode(locked || !canEdit ? "tracking" : "edit");
      } catch {
        if (!cancelled) setMode("tracking");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [registrationId]);

  if (loading) {
    return (
      <PartnerCommissionPageShell
        title="ثبت درخواست برای متقاضی"
        description="در حال بارگذاری..."
        loading
      />
    );
  }

  if (mode === "tracking") {
    return (
      <ContractorAssistedRegistrationTrackingPage
        registrationId={registrationId}
        listBackPath={LIST_BACK_PATH}
      />
    );
  }

  return (
    <AssistedRegistrationPage
      api={ContractorAssistedRegistrationApi}
      pageShell={PartnerCommissionPageShell}
      title="ثبت درخواست برای متقاضی"
      description="ثبت درخواست نیروگاه برای متقاضی با تأیید موبایل، تکمیل پروفایل و ارسال فرم درخواست."
      submitLockedMessage="درخواست متقاضی ثبت شد و وارد مرحله بررسی سولارنت گردید. امکان ویرایش توسط پیمانکار وجود ندارد."
      listBackPath={LIST_BACK_PATH}
    />
  );
};

const ContractorAssistedRegistrationPage = () => {
  const [searchParams] = useSearchParams();
  const registrationId = readAssistedRegistrationIdFromQuery(searchParams);
  const isNew = searchParams.get(ASSISTED_REGISTRATION_NEW_QUERY) === "1";

  if (!registrationId && !isNew) {
    return <ContractorAssistedRegistrationListPage />;
  }

  if (registrationId && !isNew) {
    return <ContractorAssistedRegistrationRouteResolver registrationId={registrationId} />;
  }

  return (
    <AssistedRegistrationPage
      api={ContractorAssistedRegistrationApi}
      pageShell={PartnerCommissionPageShell}
      title="ثبت درخواست برای متقاضی"
      description="ثبت درخواست نیروگاه برای متقاضی با تأیید موبایل، تکمیل پروفایل و ارسال فرم درخواست."
      submitLockedMessage="درخواست متقاضی ثبت شد و وارد مرحله بررسی سولارنت گردید. امکان ویرایش توسط پیمانکار وجود ندارد."
      listBackPath={LIST_BACK_PATH}
    />
  );
};

export default ContractorAssistedRegistrationPage;
